import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Slide, SlideHeader, itemVariants } from '../Slide';
export function SlideProduct() {
  return <Slide data-id="element-179">
      <SlideHeader data-id="element-180">Product</SlideHeader>

      <div className="flex-1 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-181">
        <div data-id="element-182">
          <motion.h2 variants={itemVariants} className="text-5xl md:text-7xl font-serif leading-[1.05] tracking-tight mb-8" data-id="element-183">
            The Waydev Agent.
          </motion.h2>
          <motion.p variants={itemVariants} className="text-2xl text-gray-400 font-light mb-12" data-id="element-184">
            Every agent makes it smarter.
          </motion.p>

          <motion.div variants={itemVariants} className="space-y-8" data-id="element-185">
            <div className="flex items-start gap-4" data-id="element-186">
              <div className="w-1.5 h-1.5 bg-white rounded-full mt-2.5" data-id="element-187" />
              <div data-id="element-188">
                <h3 className="text-xl font-medium mb-1" data-id="element-189">Skills</h3>
                <p className="text-gray-400" data-id="element-190">
                  Pre-built analytical capabilities to query engineering data,
                  identify bottlenecks, and generate reports autonomously.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-191">
              <div className="w-1.5 h-1.5 bg-white rounded-full mt-2.5" data-id="element-192" />
              <div data-id="element-193">
                <h3 className="text-xl font-medium mb-1" data-id="element-194">
                  MCP (Model Context Protocol)
                </h3>
                <p className="text-gray-400" data-id="element-195">
                  Standardized integration layer allowing any LLM or external
                  agent to read from and write to the Waydev memory layer.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-196">
              <div className="w-1.5 h-1.5 bg-white rounded-full mt-2.5" data-id="element-197" />
              <div data-id="element-198">
                <h3 className="text-xl font-medium mb-1" data-id="element-199">
                  RL Loop on Customer Insights
                </h3>
                <p className="text-gray-400 mb-4" data-id="element-200">
                  Continuous reinforcement learning at the code-completion
                  level. Removes the barriers of prompting — no need to be an
                  expert to get expert-level output.
                </p>
                <div className="grid grid-cols-2 gap-4 max-w-md" data-id="element-201">
                  <div className="border-l border-white pl-3" data-id="element-202">
                    <div className="font-serif text-2xl md:text-3xl text-white leading-none mb-1" data-id="element-203">
                      −40%
                    </div>
                    <div className="text-[10px] uppercase tracking-widest text-gray-500 leading-tight" data-id="element-204">
                      Token usage on completions
                    </div>
                  </div>
                  <div className="border-l border-white pl-3" data-id="element-205">
                    <div className="font-serif text-2xl md:text-3xl text-white leading-none mb-1" data-id="element-206">
                      +70%
                    </div>
                    <div className="text-[10px] uppercase tracking-widest text-gray-500 leading-tight" data-id="element-207">
                      Code generation accuracy
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div variants={itemVariants} className="relative aspect-square border border-gray-800 flex items-center justify-center p-8" data-id="element-208">
          {/* ASCII / Line Art Diagram representation */}
          <div className="font-mono text-xs md:text-sm text-gray-500 leading-tight whitespace-pre" data-id="element-209">
            {`
    ┌───────────────────────┐
    │                       │
    │     CUSTOMER DATA     │
    │                       │
    └──────────┬────────────┘
               │
               ▼
    ┌───────────────────────┐
    │                       │
    │      MCP SERVER       │
    │                       │
    └──────────┬────────────┘
               │
               ▼
    ┌───────────────────────┐
    │                       │
    │    WAYDEV AGENT       │◄──┐
    │    (Skills + Memory)  │   │
    │                       │   │
    └──────────┬────────────┘   │
               │                │
               ▼                │ RL LOOP
    ┌───────────────────────┐   │
    │                       │   │
    │    ACTION / INSIGHT   ├───┘
    │                       │
    └───────────────────────┘
`}
          </div>
        </motion.div>
      </div>
    </Slide>;
}